// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__KOZzS","walletId":"styles_walletId__OnsNZ","iconsWrapper":"styles_iconsWrapper__8ZYwx","icon":"styles_icon__62GZx"};